// extracted by mini-css-extract-plugin
export default {"lang__btn":"styles_lang__btn__JG5T8","lang__dropdown":"styles_lang__dropdown__nzeG4","flag":"styles_flag__yMD8P"};